if (!customElements.get('bonus-badge')) {
    customElements.define(
      'bonus-badge',
      class BonusBadge extends HTMLElement {
        constructor() {
            super();
            this.attachShadow({ mode: 'open' });
  
            // Get attributes
            const sectionId = this.getAttribute('section-id') || 'default';
            let badgeUrl =  this.getAttribute('badge-url') || '';
            const rewardsBadgeUrl =  this.getAttribute('rewards-badge-url') || '';
            const badgeText =  this.getAttribute('badge-text') || '';
            const isFreeGift =  this.getAttribute('is-free-gift') === 'true';
            const savedLoyalty = localStorage.getItem("_tcloyalty");
            const savedDiscount = localStorage.getItem("_tcdiscount");
            const loyaltyAppInstalled = typeof window.loyaltyGlobalStyles !== "undefined";

            /*
            console.log("bb 1", badgeUrl);
            console.log("bb 2", badgeText);
            console.log("bb 3", isFreeGift);
            console.log("bb 4", rewardsBadgeUrl);
            console.log("bb 5", savedLoyalty);
            console.log("bb 6", savedDiscount);
            */
           
            const showRewards = savedLoyalty !== "INACTIVE" || (!savedDiscount || savedDiscount !== "GPSLT");
            if (isFreeGift && showRewards && loyaltyAppInstalled) {
              /* console.log("bb 7 here"); */
              badgeUrl = rewardsBadgeUrl;
            }
          
            this.shadowRoot.innerHTML = `
                 <img width="60" height="60" src="${badgeUrl}" alt="${ badgeText }">
            `;
        }
    })
  
}